export const checkSession = async () => {
  try {
    const res = await fetch('/api/admin/me', { credentials: 'include' });
    if (!res.ok) return { authenticated: false };
    return await res.json();
  } catch (err) {
    return { authenticated: false };
  }
};

export const logout = async () => {
  try {
    await fetch('/api/admin/logout', { method: 'POST', credentials: 'include' });
  } catch (err) {
    // ignore
  }
};

export const fetchProjects = async () => {
  const res = await fetch('/api/admin/projects', { credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to load projects');
  return data.projects || [];
};

export const createProject = async ({ name, agentId, defaultTag, slug }) => {
  const res = await fetch('/api/admin/projects', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name, agentId, defaultTag, slug }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to create project');
  return data.project;
};

export const updateProject = async (slug, updates) => {
  const res = await fetch(`/api/admin/projects/${encodeURIComponent(slug)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(updates),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to update project');
  return data.project;
};

export const deleteProject = async (slug) => {
  const res = await fetch(`/api/admin/projects/${encodeURIComponent(slug)}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to delete project');
  return true;
};

export const saveLinks = async ({ campaign, records, batchLabel }) => {
  const res = await fetch('/api/admin/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ campaign, records, batchLabel }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to save links');
  return data;
};

export const fetchLinks = async (campaign) => {
  const res = await fetch(`/api/admin/links?campaign=${encodeURIComponent(campaign)}`, {
    credentials: 'include',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to load links');
  return data.rows || [];
};

export const fetchExistingIds = async (campaign) => {
  const res = await fetch(
    `/api/admin/existing-ids?campaign=${encodeURIComponent(campaign)}`,
    { credentials: 'include' }
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) return new Set();
  return new Set((data.ids || []).map(String));
};
